import axios from 'axios';
import {
    LIST_PAYMENT_METHODS_REQUEST,
    LIST_PAYMENT_METHODS_SUCCESS,
    LIST_PAYMENT_METHODS_FAILURE,
    LIST_PAYMENT_METHODS_RESET,
    BILLING_ACTION_REQUEST,
    BILLING_ACTION_SUCCESS,
    BILLING_ACTION_FAILURE,
    BILLING_ACTION_RESET,
} from './BillingTypes';
import { getActiveSpecialty } from 'util/specialtyCollections';

// -------- Payment methods list --------
export const listPaymentMethodsReset = () => ({ type: LIST_PAYMENT_METHODS_RESET });

export const listPaymentMethods = () => (dispatch) => {
    dispatch({ type: LIST_PAYMENT_METHODS_REQUEST });
    return axios.post('/billing/listPaymentMethods', {})
        .then(res => {
            dispatch({ type: LIST_PAYMENT_METHODS_SUCCESS, payload: res.data });
            return res.data;
        })
        .catch(err => {
            const msg = err.response?.data?.error || err.message;
            dispatch({ type: LIST_PAYMENT_METHODS_FAILURE, payload: msg });
            throw err;
        });
};

// -------- Shared action dispatchers --------
export const billingActionReset = () => ({ type: BILLING_ACTION_RESET });

const runBillingAction = (actionKey, axiosCallFn) => (dispatch, getState) => {
    dispatch({ type: BILLING_ACTION_REQUEST, payload: { action: actionKey } });
    return axiosCallFn(getState)
        .then(res => {
            dispatch({ type: BILLING_ACTION_SUCCESS, payload: { action: actionKey, data: res.data } });
            return res.data;
        })
        .catch(err => {
            const msg = err.response?.data?.error || err.message;
            dispatch({ type: BILLING_ACTION_FAILURE, payload: { action: actionKey, error: msg } });
            throw err;
        });
};

export const ensureCustomer = () =>
    runBillingAction('ensureCustomer', () => axios.post('/billing/ensureCustomer', {}));

export const createBillingSetupIntent = () =>
    runBillingAction('createSetupIntent', () => axios.post('/billing/createSetupIntent', {}));

export const setDefaultPaymentMethod = (paymentMethodId) =>
    runBillingAction('setDefault', () => axios.post('/billing/setDefaultPaymentMethod', { paymentMethodId }));

export const removePaymentMethod = (paymentMethodId) =>
    runBillingAction('remove', () => axios.post('/billing/removePaymentMethod', { paymentMethodId }));

export const cancelTrialAutoCharge = () =>
    runBillingAction('cancelTrialAutoCharge', (getState) =>
        axios.post('/billing/cancelTrialAutoCharge', { specialty: getActiveSpecialty(getState) }));

export const resumeTrialAutoCharge = () =>
    runBillingAction('resumeTrialAutoCharge', (getState) =>
        axios.post('/billing/resumeTrialAutoCharge', { specialty: getActiveSpecialty(getState) }));

export const updateTrialPlan = (selectedPlanId) =>
    runBillingAction('updateTrialPlan', (getState) =>
        axios.post('/billing/updateTrialPlan', { selectedPlanId, specialty: getActiveSpecialty(getState) }));

export const purchaseWithSavedCard = ({ planId, paymentMethodId, specialty, isAddon, isBundle, bundleId } = {}) =>
    runBillingAction('purchaseWithSavedCard', (getState) =>
        axios.post('/billing/purchaseWithSavedCard', {
            planId,
            paymentMethodId,
            specialty: specialty || getActiveSpecialty(getState),
            isAddon: isAddon || false,
            isBundle: isBundle || false,
            bundleId: bundleId || '',
        }));

export const confirmSavedCardAfterAction = (paymentIntentId, invoiceId, { specialty, isAddon, isBundle, bundleId } = {}) =>
    runBillingAction('confirmSavedCardAfterAction', (getState) =>
        axios.post('/billing/confirmSavedCardAfterAction', {
            paymentIntentId,
            invoiceId,
            specialty: specialty || getActiveSpecialty(getState),
            isAddon: isAddon || false,
            isBundle: isBundle || false,
            bundleId: bundleId || '',
        }));
